import { decode } from './decode.js';

/**
 * Returns true if the node selector match with the given selector
 */
export const match = (source: string | Buffer, selector: string | Buffer) => {
  const sourceBuffer = Buffer.isBuffer(source) ? source : decode(source);
  const selectorBuffer = Buffer.isBuffer(selector) ? selector : decode(selector);

  if (sourceBuffer.length > selectorBuffer.length) {
    return false;
  }

  const sourceView = new DataView(sourceBuffer.buffer);
  const selectorView = new DataView(selectorBuffer.buffer);

  for (let i = 0; i < sourceBuffer.length; i += 2) {
    if (sourceView.getUint16(i, true) !== selectorView.getUint16(i, true)) {
      return false;
    }
  }

  return true;
};
